<span><ng-content></ng-content></span>
<div mat-ripple [matRippleColor]="rippleColour"></div>
